$bog_vmap_app_history_snap $mol_button_minor
	moment \
	author \
	change \
	preview \
	editable false
	enabled <= editable
	hint \Вернуть документ к этому снимку. Текущее состояние ляжет снимком, поэтому возврат тоже отменяем
	click? <=> back? null
	sub /
		<= Sign $mol_labeler
			label /
				<= moment
				<= change
				<= author
			content /
				<= Preview $mol_text_code
					text <= preview
					Copy null
